<template>
  <div class="flex items-center justify-center flex-col">
    <empty-state :size="compSize" v-if="!isDashboardAccounts" />
    <empty-state-3 v-else />
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    use: {
      type: String,
      default: () => ''
    }
  },
  components: {
    EmptyState: () => import('@/assets/icons/EmptyState.vue'),
    EmptyState3: () => import('@/assets/v2/icons/EmptyState3.vue')
  },
  computed: {
    compSize () {
      return this.isDashboard
        ? 'h-54 w-54'
        : this.isReceivePayment
        ? 'h-48 w-48'
        : 'h-72 w-72 md:h-80 md:w-80'
    },
    isDashboard () {
      return this.use === 'dashboard'
    },
    isReceivePayment () {
      return this.use === 'receive-payment'
    },
    isDashboardAccounts () {
      return this.use === 'dashboard-accounts'
    }
  }
}
</script>

<style></style>
